import { EllipsisOutlined, UserDeleteOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import { DropdownLabel } from '@/shared/components';

import styles from './OptionsCell.module.scss';

type TProps = {
  openExpulsionModalCb: VoidFunction;
};

export const OptionsCell = ({ openExpulsionModalCb }: TProps) => {
  const dropdownItems = [
    {
      key: 'exclude',
      onClick: openExpulsionModalCb,
      label: (
        <div className={styles.exclude}>
          <UserDeleteOutlined className={styles['dropdown-icon']} />
          <DropdownLabel text="Отчислить" />
        </div>
      ),
    },
  ];

  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        items: dropdownItems,
        onClick: (dropdownItem) => {
          dropdownItem.domEvent.stopPropagation();
        },
      }}
      classNames={{
        root: styles['dropdown-overlay'],
      }}
    >
      <Button
        className={styles['dropdown-button']}
        onClick={(e) => e.stopPropagation()}
      >
        <EllipsisOutlined />
      </Button>
    </Dropdown>
  );
};
